module.exports = __webpack_public_path__ + "img/menu_food_new.9c1b90f2.png";